import React, {useState} from "react";
import LeaderboardTable from "./leaderboards/LeaderboardTable";
import {useSelector} from "react-redux";
import {getLeaderboard, getUserStore, getIsLoadedLeaderboards} from "modules/selectors";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {LeaderboardsTabsType} from "modules";
import {Preloader} from "components/Preloader";

const NotFound = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100px;
	font-weight: 700;
	padding: 0 20px;
	text-align: center;
`;

interface IProps {
	firstPage: number;
	lastPage: number;
	currentPage: number;
	leaderboards: ReturnType<typeof getLeaderboard>;
	setPage: (page: number) => void;
	selectedTab: LeaderboardsTabsType;
}

const Leaderboard: React.FC<IProps> = (props) => {
	const i18n = useTranslation();
	const isLoaded = useSelector(getIsLoadedLeaderboards);
	const user = useSelector(getUserStore);
	const [isNeedToScroll, setIsNeedToScroll] = useState(false);
	const {leaderboards} = props;

	return leaderboards.ranks.length ? (
		<LeaderboardTable
			userId={user.currentUser?.id || 0}
			isLoading={!isLoaded}
			isNeedToScroll={isNeedToScroll}
			setIsNeedToScroll={setIsNeedToScroll}
			{...props}
		/>
	) : isLoaded ? (
		<NotFound>
			{i18n.t("leaderboards.table.empty", "Leaderboards will appear after first day")}
		</NotFound>
	) : (
		<Preloader noBackground={true} />
	);
};

export default Leaderboard;
